import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SandwitchMenuComponent } from './sandwitch-menu.component';
import { SharedModule } from 'src/app/shared/shared.module';



@NgModule({
  declarations: [
    SandwitchMenuComponent
  ],
  exports: [
    SandwitchMenuComponent
  ],
  imports: [
    CommonModule,
    SharedModule
  ]
})
export class SandwitchMenuModule { }
